import React from 'react'
import {map} from 'lodash'
import {Carousel, Image} from 'react-bootstrap'

export function isOnUploadSlide (index, indexOfUploadSlide) {
  return index === indexOfUploadSlide
}

export function direction (total, prev, index) {
  if (prev === index) return
  if (index === 0 && (total - 1) === prev) {
    return 'next'
  }
  return prev > index ? 'prev' : 'next'
}

export function switchToSlide (slider, totalSlides, slideIndex) {
  if (slider.getActiveIndex === slideIndex) { return undefined }
  slider.setState({
    previousActiveIndex: slider.getActiveIndex(),
    direction: direction(totalSlides, slider.getActiveIndex(), slideIndex),
    activeIndex: slideIndex
  })
  slider.props.onSelect(slideIndex)
}

export function renderDescriptions (photos, currentSlide) {
  return map(photos, (item, index) => {
    return (<div key={index} className={currentSlide === index ? 'CaptionPhotosBox CaptionPhotosActive' : 'CaptionPhotosBox'}>
      <b>{item.title_fa}</b>
      <br />
      {item.description_fa}
    </div>
    )
  })
}

export function renderPhotos (photos, onClickHandler) {
  return map(photos, (photo, index) => {
    return (
      <Carousel.Item key={index}>
        <Image src={photo.url.orginal} onClick={onClickHandler} />
      </Carousel.Item>
    )
  })
}

export function giveColSizeWhen (showingPhotos) {
  return showingPhotos ? 8 : 12
}



// WEBPACK FOOTER //
// ./src/components/NewHorse/Slider/SlideHelper.js